import { useMytaverseEvent } from '@core/dashboard/providers';

/**
 * True while the myta-streams seat is being replaced: the reconnect loader owns the screen and the
 * engine behind it is gone, so in-world surfaces hide until the picture is back. Always false on the
 * other stream providers, which raise no such flag.
 */
export const useHiddenWhileReconnecting = (): boolean => {
  const { mytaStreams } = useMytaverseEvent() || {};
  return !!mytaStreams?.reconnecting;
};
